"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var icons_1 = require("@lift/assets/dist/assets/globals/icons");
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var LftTypography_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftTypography"));
var react_1 = __importStar(require("react"));
var tags_ga_1 = require("../../utils/tags-ga");
var accordion_styles_1 = require("./accordion.styles");
var Accordion = function (_a) {
    var children = _a.children, id = _a.id, className = _a.className, noBorder = _a.noBorder, noBg = _a.noBg, testId = _a.testId, gaCategory = _a.gaCategory, gaAction = _a.gaAction, gaLabel = _a.gaLabel, gaEventType = _a.gaEventType, headerTitle = _a.headerTitle, expanded = _a.expanded;
    var content = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(!!expanded), active = _b[0], setActive = _b[1];
    var toggleAccordion = function () {
        setActive(!active);
    };
    var classNameActive = (0, react_1.useMemo)(function () { return (active ? 'active' : ''); }, [active]);
    var classNameIconRotate = (0, react_1.useMemo)(function () { return (active ? 'accordion-icon rotate' : 'accordion-icon'); }, [active]);
    var idBtnAccordion = "btn-accordion-".concat(headerTitle);
    return (react_1.default.createElement(tags_ga_1.TagsGa, { category: gaCategory, action: gaAction, label: gaLabel, eventType: gaEventType },
        react_1.default.createElement(accordion_styles_1.AccordionSectionStyled, { id: id, className: "".concat(classNameActive, " ").concat(className), noBorder: noBorder, noBg: noBg },
            react_1.default.createElement(accordion_styles_1.AccordionHeaderStyled, { id: idBtnAccordion, "data-testid": testId, className: classNameActive, onClick: toggleAccordion, noBg: noBg, "aria-expanded": active, "aria-controls": "accordion-body" },
                react_1.default.createElement(LftTypography_1.default, { component: "paragraph", size: "small" }, headerTitle),
                react_1.default.createElement(accordion_styles_1.AccordionHeaderChevronStyled, { className: "".concat(classNameActive, " ").concat(classNameIconRotate) },
                    react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.ChevronDown, size: "md" }))),
            react_1.default.createElement(accordion_styles_1.AccordionBodyStyled, { id: "accordion-body", ref: content, className: "".concat(classNameActive, " accordion-content"), noBorder: noBorder, noBg: noBg },
                children,
                react_1.default.createElement("button", { className: "somenteLeitorDeTela absolute", onClick: function () {
                        setActive(false);
                        document.getElementById(idBtnAccordion).focus();
                    }, "data-testid": "fechar-accordion-".concat(headerTitle, "-leitor-tela") },
                    "Fechar conte\u00FAdo ",
                    headerTitle)))));
};
exports.Accordion = Accordion;
